<template>
    <div class="warnBlock" :style="{ margin }">
        <svg-sprite height="20" width="20" icon-id="warn" :style="`color: ${getColor}`"></svg-sprite>
        <span class="warnBlock_text" :class="{'redText': isRed, 'orangeText': isOrange}">{{ text }}</span>
    </div>
</template>

<script>
export default {
	name: "WarnBlock",
	props: {
		isRed: Boolean,
		isOrange: Boolean,
		text: String,
		margin: {
			type: String,
			default: () => "0 0 10px 0"
		}
	},
	computed: {
		getColor() {
			if (this.isOrange) return "#F49741";
			if (!this.isRed) return "#8F90A6";
			return "#e91e63";
		}
	}
};
</script>

<style scoped lang="scss">
.warnBlock {
    display: flex;
    align-items: center;

    &_text {
        display: inline-block;
        margin-left: 5px;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0.25px;
        color: #8F90A6;

        &.redText {
            color: #e91e63;
        }

		    &.orangeText {
			    color: #F49741;
		    }
    }
}
</style>
